import { FC } from "react";

import { Pie, measureTextWidth } from "@ant-design/plots";
// import Plot from "react-plotly.js";
import Plotly from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";
import get from "lodash/get";
import map from "lodash/map";
import { fixedDecimal } from "@utils/helpers";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";

const Plot = createPlotlyComponent(Plotly);

const DonutChart: FC<any> = (props) => {
  const isCostVisible = props?.isCostVisible;
  const data = props?.data ? props.data : [];
  const filteredData = data.filter((item: any) => item.cost > 0);

  let total = filteredData.reduce((prev:any, current:any)=> prev + current.cost, 0)
  total = Math.round(total)?.toLocaleString();

  function renderStatistic(containerWidth: any, text: any, style: any) {
    const { width: textWidth, height: textHeight } = measureTextWidth(
      text,
      style
    );
    const R = containerWidth / 2;

    let scale = 1;

    if (containerWidth < textWidth) {
      scale = Math.min(
        Math.sqrt(
          Math.abs(
            Math.pow(R, 2) /
              (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2))
          )
        ),
        1
      );
    }

    const textStyleStr = `width:${containerWidth}px;`;
    return `<div style="${textStyleStr};font-size:${scale}em;line-height:${
      scale < 1 ? 1 : "inherit"
    };">${text}</div>`;
  }

  const config = {
    appendPadding: 10,
    data,
    angleField: "cost",
    colorField: "claim_type",
    radius: 1,
    innerRadius: 0.8,
    meta: {
      cost: {
        formatter: (val: any) => `$ ${val?.toFixed()}`,
      },
    },
    tooltip: {
      domStyles: {
        "g2-tooltip": {
          backgroundColor: "#091e42",
          color: "#fff",
          borderRadius: "8px",
        },
      },
    },
    label: {
      type: "inner",
      offset: "-50%",
      content: "",
      style: {
        textAlign: "center",
      },
      autoRotate: false,
      maxWidthRatio: 5,
    },
    statistic: {
      title: {
        offsetY: -15,
        customHtml: (container: any, _view: any, datum: any) => {
          const { width, height } = container.getBoundingClientRect();
          const d = Math.sqrt(Math.pow(width / 2, 2) + Math.pow(height / 2, 2));
          const text = datum ? datum.type : "";
          return renderStatistic(d, text, {
            fontSize: 28,
          });
        },
      },
      content: {
        offsetY: -5,
        style: {
          fontSize: "14px",
        },
        customHtml: (container: any, _view: any, datum: any, data: any) => {
          const { width } = container.getBoundingClientRect();
          const text = `$${total}`;
          return renderStatistic(width, text, {
            fontSize: 12,
          });
        },
      },
    },
  };
  return props.type === "plot" ? (
    total === "0" ? (
      <div className="no-data">
        <DataNotFound message={NO_DATA_FOUND} />
      </div>
    ) : (
      <Plot
        className="encounter-data-donut-chart"
        data={[
          {
            values: map(filteredData, (item) => {
              return item.cost;
            }),
            labels: map(filteredData, (item) => {
              return isCostVisible ? `${item.claim_type}: $${fixedDecimal(item.cost, 2)}` : item.claim_type;
            }),
            domain: { column: 0 },
            hoverinfo: isCostVisible ? "label" : "label+value",
            hole: 0.8,
            textinfo: "none",
            type: "pie",
            marker: {
              colors: filteredData?.map((item: any) => props?.getClaimTypeColor(item.claim_type)), // Use the color function here
            },
          },
        ]}
        layout={{
          legend: {
            orientation: "h",
            y: -0.1,
            x: 0.5,
            xanchor: "center",
            font: {
              size: 14,
              color: "#7A869A",
              family: "Fira Sans",
            },
          },

          annotations: [
            {
              font: {
                size: 14,
                color: "#000",
                family: "Fira Sans",
              },
              showarrow: false,
              text: `<b>$ ${total}</b>`,
              x: 0.5,
              y: 0.5,
            },
          ],
          height: 130,
          width: 280,
          showlegend: false,
          margin: { l: 20, r: 0, b: 5, t: 5 },
        }}
        onClick={(e) => {
          if (data.length > 1) {
            let record: any = {};
            for (let i = 0; i < e.points.length; i++) {
              record.x = get(e.points[i], "value", 0);
              record.y = get(e.points[i], "label", 0);
            }
            props.handleClick(record.y);
          }
        }}
        onLegendClick={() => {
          return false;
        }}
      />
    )
  ) : (
    <Pie {...config} />
  );
};

export default DonutChart;
